import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { shallowEqual } from "react-redux";
import { useApplyRedeemMutation, useApplyEConfirmMutation, useModifyRedeemMutation, useRequestReRedeemMutation } from "src/api/redeemAPI";
import { useAppSelector } from "src/store/actions/action";
import moment from "moment";
import imageCompression from "browser-image-compression";
import Box from "../common/Box";
import Button from "../common/Button";
import IconButton from "../common/IconButton";
import noRedeem from "src/assets/images/no_re_img.png";
import ImageModal, { RefProps } from "../common/ImageModal";
import styled from "styled-components";
import SVG from "src/utils/SVG";
import Slider from "react-slick";

interface IDetailItemProps {
  data?: any;
  confirm?: string;
  storeId?: string;
  executeIdx?: string;
  redeemIdx?: number;
  redeemLength?: number;
  sendReRedeem(): void;
}

const compressionOption = {
  maxSizeMB: 1,
  maxWidthOrHeight: 1920,
  initialQuality: 0.7,
};

const RedeemDetailItem = (props: IDetailItemProps) => {
  // global
  const navigate = useNavigate();
  const imageServerIp = process.env.REACT_APP_IMAGE_SERVER_IP;
  const userInfo = useAppSelector((state) => state.userReduce.userInfo, shallowEqual);

  // API
  const [insertRedeem] = useApplyRedeemMutation();
  const [insertModifiedRedeem] = useModifyRedeemMutation();
  const [insertConfirm] = useApplyEConfirmMutation();
  const [requestAgain] = useRequestReRedeemMutation();

  const [redeemInfo, setRedeemInfo] = useState<any>();
  const [redeemGuide, setRedeemGuide] = useState("");
  const [redeemReExecute, setRedeemReExecute] = useState("");
  const [fileImage, setFileImage] = useState<File>();
  const [fileImageUrl, setFileImageUrl] = useState("");
  const [textContents, setTextContents] = useState("");
  const [modifyTextContents, setModifyTextContents] = useState("");
  const [SModified, setSModified] = useState(false);
  const [currentImg, setCurrentImg] = useState("");
  const [redeemTimes, setRedeemTimes] = useState(0);
  const [finish, setFinish] = useState(false);
  const [noUpload, setNoUpload] = useState(true);

  useEffect(() => {
    if (props.redeemLength) {
      setRedeemTimes(props.redeemLength - 1);
    }
  }, [props]);

  useEffect(() => {
    if (props.data) {
      setRedeemInfo(props.data);

      // 본사 가이드 이미지 : R
      const guideImg = props.data.reExecuteImages.filter((e: any) => e.type === "R");
      if (guideImg.length > 0) {
        setRedeemGuide(guideImg[0].img_url);
      } else {
        setRedeemGuide("");
      }

      // 매장 재이행 이미지 : E
      const reExecuteImg = props.data.reExecuteImages.filter((e: any) => e.type === "E");
      if (reExecuteImg.length > 0) {
        setRedeemReExecute(reExecuteImg[0].img_url);
      } else {
        setRedeemReExecute("");
      }

      setModifyTextContents(props.data.re_execute_contents ? props.data.re_execute_contents : "");
    }
  }, [props.data]);

  // 매장 재이행 이미지 등록
  const saveFileImage = async (e: React.ChangeEvent<HTMLInputElement>) => {
    const selectFiles = e.target.files;

    if (selectFiles !== null) {
      try {
        if (selectFiles.length > 0) {
          if (selectFiles.length > 1 || fileImage !== undefined) {
            alert("재이행 이미지는 한개만 등록할수 있습니다.");
            return;
          }
          let totalFileSize = 0;
          for (let i = 0; i < selectFiles.length; i++) {
            totalFileSize += Number(selectFiles[i].size);
            const fileType = selectFiles[i].type;
            const oneFileSize = Number(selectFiles[i].size / 1024);
            // 이미지 로직
            if (String(fileType).indexOf("image") > -1) {
              if (oneFileSize > 10000) {
                // 이미지 파일
                alert("하나의 사진 파일이 10MB보다 클 수 없습니다.");
                return;
              }
            }
            if (totalFileSize / 1024 > 150000) {
              alert("전체 파일 사이즈가 150MB를 넘길 수 없습니다.");
              return;
            }
          }

          if (String(selectFiles[0].type).includes("image") == true) {
            const compressedFile = await imageCompression(selectFiles[0], compressionOption);
            const newFile = new File([compressedFile], compressedFile.name, { type: selectFiles[0].type });
            const fileUrl = await imageCompression.getDataUrlFromFile(newFile);
            setFileImage(newFile);
            setFileImageUrl(fileUrl);
          }
        }
      } catch (error) {
        alert("이미지 업로드 실패 다시 시도해 주세요");
        console.error("imageUpload Error", error);
      }
    }
  };

  // 매장 재이행 등록 이미지 삭제
  const deleteFileImage = () => {
    setFileImage(undefined);
    setFileImageUrl("");
  };

  // 매장 재이행 등록 텍스트
  const handleSetTextarea = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    setTextContents(e.target.value);
  };

  // 매장 재이행 등록, 수정 이미지 필수 체크
  const checkBlank = () => {
    let result = false;
    if (fileImage === undefined) {
      alert("재이행한 사진을 첨부해주세요.");
      result = false;
    } else {
      result = true;
    }
    return result;
  };

  //수정시 첨부파일 확인
  const checkModifyFile = () => {
    if (noUpload === false && fileImage === undefined) {
      alert("재이행한 사진을 첨부해주세요.");
      return false;
    }
    return true;
  };
  // 매장 재이행 등록
  const applyNewRedeem = async () => {
    console.log(checkBlank());
    if (!checkBlank()) return;
    try {
      const data = new FormData();
      fileImage && data.append("image", fileImage);
      data.append("re_execute_contents", textContents);
      await insertRedeem({ re_execute_idx: redeemInfo.re_execute_idx, data: data });
      window.location.reload();
    } catch (error) {
      alert("재이행 등록에 실패했습니다.");
    }
  };

  // 매장 재이행 수정 텍스트
  const handleSetModifyTextarea = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    setModifyTextContents(e.target.value);
  };

  // 매장 재이행 수정
  const modifySRedeem = () => {
    setSModified(true);
  };

  // 매장 재이행 수정 등록
  const applyModifiedRedeem = async () => {
    if (!checkModifyFile()) return;
    try {
      const data = new FormData();
      fileImage && data.append("image", fileImage);
      data.append("re_execute_contents", modifyTextContents);
      await insertModifiedRedeem({ re_execute_idx: redeemInfo.re_execute_idx, data: data });
      window.location.reload();
    } catch (error) {
      alert("재이행 수정에 실패했습니다.");
    }
  };

  // 본사 재이행 재요청
  const requestRedeemAgain = () => {
    requestAgain({
      re_execute_idx: props.executeIdx,
      data: redeemInfo,
    });
  };

  // 본사 확인 완료
  const applyEConfirmed = async () => {
    setFinish(true);
    await insertConfirm({ re_execute_idx: redeemInfo.re_execute_idx });
    navigate(-1);
  };

  // 이미지 모달
  const imageModalRef = React.useRef<RefProps>(null);
  const showImgModal = (url: string) => {
    setCurrentImg(url);
    if (imageModalRef.current) imageModalRef.current.modalOpen();
  };

  const setImgSlide = {
    useTransform: false,
    dots: true,
    infinite: false,
    speed: 100,
    fade: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    cssEase: "ease-out",
  };

  return (
    <>
      {redeemInfo && (
        <>
          <CompareImgBox>
            <div className="origin">
              <span className="title">원본</span>
              <div className="img-box" onClick={() => showImgModal(redeemInfo.deficient_img_image.img_url)}>
                <img src={imageServerIp + redeemInfo.deficient_img_image.img_url} alt="더미이미지" />
              </div>
            </div>
            <div className="guide">
              <span className="title">가이드</span>
              <div className="img-box" onClick={() => showImgModal(redeemGuide)}>
                {redeemGuide ? <img src={imageServerIp + redeemGuide} alt="더미이미지" /> : <img src={noRedeem} alt="더미이미지" />}
              </div>
            </div>
          </CompareImgBox>
          <Box pd="0 15px 40px">
            <RedeemReason>
              <p className="cmt">{redeemInfo.deficient_reason}</p>
              <p className="date">{moment(redeemInfo.insert_date).format("YYYY.MM.DD HH:mm")}</p>
            </RedeemReason>
          </Box>

          {/* 매장 재이행 등록 : 재이행 요청받은 매장만 노출 */}
          {userInfo.user_type === "S" && userInfo.user_id === props.storeId && redeemInfo && redeemInfo.execute_yn === "N" && props.confirm === "N" && (
            <>
              <RedeemComfirmBox>
                <p>재이행</p>
                <div className="add-img">
                  {fileImageUrl ? (
                    <PreviewImg>
                      <div>
                        <img src={fileImageUrl} alt="더미이미지" />
                      </div>
                      <IconButton btnName="미리보기 삭제하기" onClick={deleteFileImage}>
                        <SVG name="thumbDel" width={24} height={24} viewBox="0 0 24 24" />
                      </IconButton>
                    </PreviewImg>
                  ) : (
                    <label htmlFor={`redeem-file`}>
                      <span className="hidden">파일업로드</span>
                      <input
                        id={`redeem-file`}
                        type="file"
                        accept="image/*,video/*,.mov,.mp4"
                        name="redeem-img"
                        onChange={(e) => {
                          saveFileImage(e);
                        }}
                      />
                    </label>
                  )}
                </div>

                <textarea placeholder={"재이행에 대한 내용을 작성해주세요!"} maxLength={1000} value={textContents} onChange={(e) => handleSetTextarea(e)} />
              </RedeemComfirmBox>

              <Box pd="0 15px 40px">
                <Button variant="contained" br="round" onClick={applyNewRedeem}>
                  등록
                </Button>
              </Box>
            </>
          )}

          {/* 매장 재이행 수정 : 수정버튼 클릭시 재이행요청받은 매장만 노출 */}
          {userInfo.user_type === "S" && SModified && redeemInfo && redeemInfo.execute_yn === "Y" && props.confirm === "N" && (
            <>
              <RedeemComfirmBox>
                <p>재이행</p>
                <div className="add-img">
                  {fileImageUrl ? (
                    <PreviewImg>
                      <div>
                        <img src={fileImageUrl} alt="더미이미지" />
                      </div>
                      <IconButton btnName="미리보기 삭제하기" onClick={deleteFileImage}>
                        <SVG name="thumbDel" width={24} height={24} viewBox="0 0 24 24" />
                      </IconButton>
                    </PreviewImg>
                  ) : redeemReExecute && noUpload ? (
                    <PreviewImg>
                      <div>
                        <img src={imageServerIp + redeemReExecute} alt="더미이미지" />
                      </div>
                      <IconButton btnName="미리보기 삭제하기" onClick={() => setNoUpload(false)}>
                        <SVG name="thumbDel" width={24} height={24} viewBox="0 0 24 24" />
                      </IconButton>
                    </PreviewImg>
                  ) : (
                    <label htmlFor={`redeem-file`}>
                      <span className="hidden">파일업로드</span>
                      <input
                        id={`redeem-file`}
                        type="file"
                        accept="image/*,video/*,.mov,.mp4"
                        name="redeem-img"
                        onChange={(e) => {
                          saveFileImage(e);
                        }}
                      />
                    </label>
                  )}
                </div>

                <textarea
                  placeholder={"수정할 내용을 작성해주세요!"}
                  maxLength={1000}
                  value={modifyTextContents}
                  onChange={(e) => handleSetModifyTextarea(e)}
                />
              </RedeemComfirmBox>

              <Box pd="0 15px 40px">
                <Button variant="contained" br="round" onClick={applyModifiedRedeem}>
                  등록
                </Button>
              </Box>
            </>
          )}

          {/* 매장, 본사 재이행 사진 있는 경우 노출 */}
          {redeemInfo && redeemInfo.execute_yn === "Y" && SModified === false && (
            <>
              {props.confirm === "Y" && redeemReExecute === "" ? (
                ""
              ) : (
                <RedeemComfirmBox>
                  <p>재이행</p>
                  <RedeemNewImg>
                    <div className="img-box" onClick={() => showImgModal(redeemReExecute)}>
                      <img src={imageServerIp + redeemReExecute} alt="더미이미지" />
                    </div>
                  </RedeemNewImg>
                  <RedeemReason>
                    <p className="cmt">{redeemInfo.re_execute_contents}</p>
                    <p className="date">{moment(redeemInfo.re_execute_date).format("YYYY.MM.DD HH:mm")}</p>
                  </RedeemReason>
                </RedeemComfirmBox>
              )}

              {props.redeemIdx === redeemTimes && (
                <>
                  {userInfo.user_type === "S" && userInfo.user_id === props.storeId && props.confirm === "N" && (
                    <BtnBox>
                      <Button variant="contained" br="round" onClick={modifySRedeem}>
                        수정
                      </Button>
                    </BtnBox>
                  )}
                </>
              )}

              {userInfo.user_type === "E" && props.confirm === "N" && (
                <BtnBox>
                  <Button variant="outlined" br="round" color="secondary" onClick={() => props.sendReRedeem()}>
                    재이행
                  </Button>
                  <Button variant="contained" br="round" onClick={applyEConfirmed}>
                    확인
                  </Button>
                </BtnBox>
              )}
            </>
          )}

          <ImageModal ref={imageModalRef}>
            <ModalImgSlide>
              <StyledSlider {...setImgSlide}>
                {[{ img_url: imageServerIp + currentImg }].map((v: any, k: number) => {
                  return (
                    <div className="img-box" key={k}>
                      <img src={v.img_url} alt={v.img_origin_name} />
                    </div>
                  );
                })}
              </StyledSlider>
            </ModalImgSlide>
          </ImageModal>
        </>
      )}
    </>
  );
};

const FinishedMes = styled.p`
  padding: 45px 15px;
  margin: 0 15px;
  border-radius: 4px;
  background: ${({ theme }) => theme.color.bgPrimary};
  color: #000;
  text-align: center;
`;

const CompareImgBox = styled.div`
  ${({ theme }) => theme.flexBox.flexMixin()}
  margin: 40px 0 16px 15px;
  > div {
    width: 50%;
    padding-right: 15px;
    &.origin {
      > .title {
        display: inline-block;
        padding: 2px 4px;
        margin-bottom: 8px;
        background-color: ${({ theme }) => theme.color.bgPrimary};
        color: #000;
      }
    }
    &.guide {
      > .title {
        display: inline-block;
        padding: 2px 4px;
        margin-bottom: 8px;
        background-color: ${({ theme }) => theme.color.main};
        color: #fff;
      }
    }
  }
  .img-box {
    ${({ theme }) => theme.imgBox.coverBox()}
  }
`;

const RedeemReason = styled.div`
  .cmt {
    margin-bottom: 16px;
    color: ${({ theme }) => theme.color.primary};
    line-height: 20px;
    word-break: break-word;
    white-space: pre-wrap;
  }
  .date {
    font-family: "Poppins";
    font-size: 12px;
    color: ${({ theme }) => theme.color.tertiary};
    line-height: 20px;
  }
`;

const RedeemComfirmBox = styled.div`
  padding: 0 15px 40px;
  > p {
    margin-bottom: 16px;
    font-weight: 700;
  }
  .add-img {
    font-size: 0;
    > label {
      position: relative;
      display: inline-block;
      width: 100%;
      padding-top: 100%;
      border: 1px dashed ${({ theme }) => theme.color.lineSecondary};
      &:before {
        position: absolute;
        top: 50%;
        left: 50%;
        content: "";
        display: block;
        width: 1px;
        height: 39px;
        margin-top: -19px;
        background-color: ${({ theme }) => theme.color.lineSecondary};
      }
      &:after {
        position: absolute;
        top: 50%;
        left: 50%;
        content: "";
        display: block;
        width: 39px;
        height: 1px;
        margin-left: -19px;
        background-color: ${({ theme }) => theme.color.lineSecondary};
      }
      > input {
        position: absolute;
        width: 1px;
        height: 1px;
        padding: 0;
        margin: -1px;
        overflow: hidden;
        clip: rect(0, 0, 0, 0);
        border: 0;
      }
    }
  }
  > textarea {
    width: 100%;
    height: 160px;
    padding: 12px 15px;
    border: none;
    border-radius: 4px;
    margin-top: 16px;
    background: ${({ theme }) => theme.color.bgPrimary};
    color: ${({ theme }) => theme.color.primary};
    font-size: 16px;
    line-height: 20px;
    resize: none;
    &::placeholder {
      color: ${({ theme }) => theme.color.tertiary};
      font-size: 14px;
    }
    &:focus {
      outline: none;
    }
  }
`;

const PreviewImg = styled.div`
  position: relative;
  font-size: 0;
  > div {
    ${({ theme }) => theme.imgBox.coverBox()}
  }
  > button {
    position: absolute;
    top: 8px;
    right: 8px;
  }
`;

const BtnBox = styled.div`
  ${({ theme }) => theme.flexBox.flexMixin()}
  padding: 0 15px 40px;
  > button {
    margin-right: 8px;
    &:last-child {
      margin-right: 0;
    }
  }
`;

const RedeemNewImg = styled.div`
  margin-bottom: 16px;
  font-size: 0;
  .img-box {
    ${({ theme }) => theme.imgBox.coverBox()}
  }
`;

const ModalImgSlide = styled.div`
  height: 100%;
  background: #ccc;
`;

const StyledSlider = styled(Slider)`
  .slick-track {
    height: 100%;
  }
  .slick-slide {
    height: 100%;
    ${({ theme }) => theme.flexBox.flexMixin("column", "center", "center")}
    > div {
      width: 100%;
      height: auto;
      overflow-y: scroll;
    }
    .img-box {
      padding-top: 0;
      text-align: center;
      > img {
        position: initial;
        top: 0;
        left: 0;
        transform: none;
      }
      > .video-wrap {
        position: initial;
        top: 0;
        left: 0;
        transform: none;
      }
    }
  }
  .slick-list {
    background: rgba(0, 0, 0, 0.5);
  }
`;

export default RedeemDetailItem;
